module.exports = __webpack_public_path__ + "img/ep-T-dosis.4ecef05a.jpg";